import httpUtils from '../../utils/HttpUtils'

class AppointmentService {

  //监理、工长、保洁、搬家预约
  async createAppointment (x) {
    var result = null;
    try {
      result = await httpUtils.post('/server/appointment/create',x);
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //验证客户是否正在预约此服务人员
  async checkAppointment (x) {
    var result = null;
    try {
      result = await httpUtils.post('/server/appointment/check/create',x);
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //预约列表
  async getAppointmentList (customerId = '', pageNo = 1) {
    var result = null;
    try {
      result = await httpUtils.post('/server/appointment/list',{customerId:customerId,pageNo:pageNo});
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //预约详情
  async getAppointmentDetail (id) {
    var result = null;
    try {
      result = await httpUtils.post('/server/appointment/detail',{id:id});
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
  async getServiceRecords(appointmentId){
    var result = null;
    try {
      result = await httpUtils.post('/server/appointment/service/records',{ appointmentId });
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //取消预约
  async cancelAppointment (id) {
    var result = null;
    try {
      result = await httpUtils.post('/server/appointment/cancel',{id:id});
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //接受预约报价
  async acceptDeal (id,priceRecordId = '') {
    var result = null;
    try {
      result = await httpUtils.post('/server/appointment/deal',{id,priceRecordId});
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //预约预付订金
  async prePayAppointment (appointment = {},deposit = 0) {
    var result = null;
    try {
      appointment.deposit = deposit;
      result = await httpUtils.post('/server/appointment/prePay/pro',appointment);
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //业主删除已取消预约
  async remove (id) {
    var result = null;
    try {
      result = await httpUtils.post('/server/appointment/remove',{id});
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //校验业主是否支付预约订金
  async checkPaymentStatus(tradeAppointmentId) {
      var result = null;
      try {
          result = await httpUtils.post('/server/appointment/check/payment/status',{tradeAppointmentId});
      } catch (e) {
          result = {code: 1, msg: '连接失败'}
      }
      return result
  }
}
export default new AppointmentService()
